import React from 'react';
import { useTranslation } from 'next-i18next';
import Button from '@components/atoms/button/button';
import Icon from '@components/atoms/icon/icon';
import { useContextSelector } from 'use-context-selector';
import { ModalContext } from '@context/modal.context';
import dynamic from 'next/dynamic';
import styles from './product-authentication-infos.module.scss';

const ProductAuthenticationModal = dynamic(
  () => import('./product-authentication-modal/product-authentication-modal'),
  {
    ssr: false,
  },
);

type ProductAuthInfoProps = {
  hasMandatoryAuthentication: boolean;
};

const ProductAuthInfo: React.FC<ProductAuthInfoProps> = ({ hasMandatoryAuthentication }) => {
  const { t } = useTranslation();
  const openModal = useContextSelector(ModalContext, (v) => v.openModal);

  const onClick = () =>
    openModal(<ProductAuthenticationModal />, {
      styles: {
        content: {
          maxWidth: '580px',
          width: '100%',
        },
      },
    });

  return (
    <>
      {hasMandatoryAuthentication ? (
        <div
          className={styles.productDetails__authentication}
          data-cy="pdp_mandatory_physical_authentication"
        >
          <Icon
            name="authentication-default"
            className={styles.productDetails__authentication__icon}
          />
          <p>{t('PRODUCT.DETAILS.PHYSICAL_AUTHENTICATION_INCLUDED', 'Physical authentication included ')}</p>
        </div>
      ) : (
        <Button
          type="submit"
          data-cy="open-authentication-modal-button"
          disableDefaultStyling
          className={`${styles.productDetails__authentication} ${styles['productDetails__authentication--clickable']}`}
          onClick={onClick}
        >
          <Icon
            name="authentication-default"
            className={styles.productDetails__authentication__icon}
          />
          <p>
            <span>{t('PRODUCT.DETAILS.BUYER_FEES.REASSURANCE')}</span>
            &nbsp;
            <u className={styles.productDetails__authentication__knowMore}>
              {t('PRODUCT.DETAILS.BUYER_FEES.MORE_INFOS')}
            </u>
          </p>
        </Button>
      )}
    </>
  );
};

export default React.memo(ProductAuthInfo);
